import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import DeleteDialog from '../../../../components/modal/DeleteDialog';
import { setDialogHandle, setIsDialogOpen } from '../../../../actions/dialog';
import { HTTPMethods } from '../../API/API';
import DeleteTitle from '../../../../components/modal/DeleteTitle';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import FormTitle from '../FormComponents/FormTitle';
import CenteredLoader from '../../components/UI/Loaders/CenteredLoader';

export const DeleteItems = (props: ICommonFormProps) => {
    const {
        formProps: {
            callAPI,
            item,
            rawProps,
            ParentComponent,
            keyLabel = 'items',
            isArrayModal,
            onDelete,
            onFailedInteraction,
        },
    }: any = props;

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const deleteLabel = `delete.${keyLabel}.`;
    const contents = (
        <>
            <p>{t(`${deleteLabel}content1`)}</p>
            <p>{t(`${deleteLabel}content2`)}</p>
        </>
    );

    const disabledMessage = t(`${deleteLabel}warning`);

    const onCancel = () => {
        if (ParentComponent) {
            dispatch(
                setDialogHandle({
                    Component: ParentComponent,
                    ComponentProps: rawProps,
                    isFormDialog: true,
                    dialogTitle: props.formProps?.title ?? t('forms.modify.title'),
                }),
            );
        } else {
            dispatch(setIsDialogOpen(false));
        }
    };

    const onSubmit = async () => {
        setIsLoading(true);
        console.log(props.formProps);
        await callAPI(HTTPMethods.DELETE, {
            query: item.id,
            params: {
                force: true,
            },
            successCall: t(`${deleteLabel}success`),
            errorCall: {
                400: t(`${deleteLabel}failure400`),
                500: t(`${deleteLabel}failure500`),
            },
        });
        if (onDelete) {
            onDelete();
        }
        await callAPI(HTTPMethods.GET);

        setIsLoading(false);

        if (props.formProps?.closeAllModals) {
            props.formProps.closeAllModals();
        }
        dispatch(setIsDialogOpen(false));
    };

    return (
        <DeleteDialog
            pre={<FormTitle title={t(`${deleteLabel}header`)} subtitle={t(`${deleteLabel}description`)} />}
            onCancel={onCancel}
            onSubmit={onSubmit}
            onClose={onCancel}
            dialogTitle={<DeleteTitle title={t(`${deleteLabel}title`)} />}
            contents={isLoading ? <CenteredLoader /> : contents}
            disabledMessage={disabledMessage}
            isDisabled={props.disabled}
            buttonText={t(`${deleteLabel}button`)}
            isArrayModal={isArrayModal}
            onDisabledClick={onFailedInteraction}
        />
    );
};
